import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

import { ApiClient } from '../api-client';
import { Respondent } from './respondent';

@Injectable()
export class RespondentService extends ApiClient {
  store: Subject<Respondent[]>;
  path = '/respondents';

  constructor(protected http: Http) {
    super(http);
    this.store = <Subject<Respondent[]>>new Subject();
  }

  getSaved(id: string): Observable<any> {
    const url = `${this.baseUrl}/respondents/${id}/report`;

    return this.get(url);
  }

  deleteRespondent(id: string): Observable<any> {
    const url = `${this.baseUrl}/g/respondents/${id}`;

    return this.delete(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/respondents.service.ts